import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { Attraction, AttractionCreate, AttractionEdit, Attractions } from './pages';

export const AttractionsEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Attractions',
      element: <Attractions />,
      path: '/',
    },
    {
      label: 'Detail',
      element: <Attraction />,
      path: '/:id',
    },
    {
      label: 'Create',
      element: <AttractionCreate />,
      path: '/new',
    },

    {
      label: 'Edit',
      element: <AttractionEdit />,
      path: '/:id/edit',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
